import { useRef } from "react";
import { motion, useMotionValue, useSpring, useScroll, useTransform, useReducedMotion } from "framer-motion";
import { MOTION, isFinePointer } from "./config";

export function ParallaxImage({ src, alt = "", className = "", imgClassName = "", max = MOTION.parallax.max, children }) {
  const ref = useRef(null);
  const reduced = useReducedMotion();
  const mx = useMotionValue(0), my = useMotionValue(0);
  const sx = useSpring(mx, { stiffness: 60, damping: 20 }), sy = useSpring(my, { stiffness: 60, damping: 20 });
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const scrollY = useTransform(scrollYProgress, [0, 1], reduced ? [0, 0] : [max, -max]);

  const onMove = (e) => {
    if (reduced || !isFinePointer()) return;
    const b = ref.current.getBoundingClientRect();
    mx.set(((e.clientX - b.left) / b.width - 0.5) * max); my.set(((e.clientY - b.top) / b.height - 0.5) * max);
  };
  return (
    <div ref={ref} className={`relative overflow-hidden ${className}`} onMouseMove={onMove} onMouseLeave={() => { mx.set(0); my.set(0); }}>
      <motion.img src={src} alt={alt} style={{ x: sx, y: reduced ? 0 : scrollY, translateY: sy, scale: 1.08 }} className={`h-full w-full object-cover will-change-transform ${imgClassName}`} />
      {children}
    </div>
  );
}

export function AnimatedCard({ children, className = "", cursor = "VIEW →", ...rest }) {
  const reduced = useReducedMotion();
  return (
    <motion.div data-cursor={cursor} whileHover={reduced ? {} : { y: -4, scale: 1.01 }} whileTap={{ scale: 0.99 }} transition={MOTION.ease.spring} className={`group ${className}`} {...rest}>
      {children}
    </motion.div>
  );
}

export function AIThinkingIndicator() {
  return (
    <div className="flex items-center gap-1 py-1" aria-label="HealthAI is thinking" data-testid="ai-thinking-indicator">
      {[0, 1, 2].map((i) => <motion.span key={i} className="h-1.5 w-1.5 rounded-full bg-[#0A192F]" animate={{ y: [0, -4, 0], opacity: [0.35, 1, 0.35] }} transition={{ duration: 1.1, repeat: Infinity, delay: i * 0.18, ease: "easeInOut" }} />)}
    </div>
  );
}
